import React, { useEffect, useState } from "react";
import moment from "moment";
import Select from "react-select";
import { useCptFilterLoading } from "../common/useCptFilterLoading";

const MONTHS = [
  { value: "1", label: "January" },
  { value: "2", label: "February" },
  { value: "3", label: "March" },
  { value: "4", label: "April" },
  { value: "5", label: "May" },
  { value: "6", label: "June" },
  { value: "7", label: "July" },
  { value: "8", label: "August" },
  { value: "9", label: "September" },
  { value: "10", label: "October" },
  { value: "11", label: "November" },
  { value: "12", label: "December" }
];

const YEARS = Array.from({ length: 7 }, (_, i) => (moment().year() - 4 + i).toString());

const PROVIDER_SELECT_STYLES = {
  control: (base, state) => ({
    ...base,
    minHeight: 44,
    borderRadius: 10,
    borderColor: state.isFocused ? "#2563eb" : "#dbe3ef",
    boxShadow: "none",
    fontSize: 14,
    "&:hover": { borderColor: state.isFocused ? "#2563eb" : "#dbe3ef" }
  }),
  valueContainer: (base) => ({ ...base, padding: "2px 12px" }),
  placeholder: (base) => ({ ...base, color: "#0f172a" }),
  indicatorSeparator: () => ({ display: "none" }),
  dropdownIndicator: (base) => ({ ...base, color: "#64748b" }),
  menu: (base) => ({ ...base, zIndex: 5 })
};

const CarePlanReviewFilters = ({
  isAdmin,
  year,
  month,
  clientId,
  careproviderIds,
  clientOptions,
  careProviderOptions,
  onApply,
  loading = false
}) => {
  const { isFilterBusy, beginSubmit } = useCptFilterLoading(loading);
  const [selectedYear, setSelectedYear] = useState(year || "");
  const [selectedMonth, setSelectedMonth] = useState(month || "");
  const [selectedClient, setSelectedClient] = useState(clientId || "");
  const [selectedProviders, setSelectedProviders] = useState(careproviderIds || []);

  useEffect(() => {
    setSelectedYear(year || "");
  }, [year]);

  useEffect(() => {
    setSelectedMonth(month || "");
  }, [month]);

  useEffect(() => {
    setSelectedClient(clientId || "");
  }, [clientId]);

  useEffect(() => {
    setSelectedProviders(careproviderIds || []);
  }, [careproviderIds]);

  const handleApply = () => {
    beginSubmit();
    onApply({
      year: selectedYear,
      month: selectedMonth,
      clientId: isAdmin ? selectedClient : "",
      careproviderIds: isAdmin ? selectedProviders : []
    });
  };

  const handleReset = () => {
    setSelectedYear("");
    setSelectedMonth("");
    setSelectedClient("");
    setSelectedProviders([]);
    beginSubmit();
    onApply({ year: "", month: "", clientId: "", careproviderIds: [] });
  };

  const selectedProviderOptions = careProviderOptions.filter((option) =>
    selectedProviders.includes(option.value)
  );

  return (
    <div className="cpt-filter-wrapper">
      <div className={`mpr-filter-card ${isFilterBusy ? "mpr-filter-card--loading" : ""}`}>
        <div className="mpr-filter-header">
          <div>
            <h4>RPM Care Plan Review</h4>
            <p>Filter by the review due date{isAdmin ? ", client, or care provider" : ""}.</p>
          </div>
        </div>
        <div className={`mpr-filter-grid ${isAdmin ? "cpr-filter-grid-admin" : "cpr-filter-grid-basic"}`}>
          <div className="mpr-filter-field">
            <label>Year</label>
            <select
              className="mpr-select"
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
              disabled={isFilterBusy}
            >
              <option value="">All Years</option>
              {YEARS.map((item) => <option key={item} value={item}>{item}</option>)}
            </select>
          </div>
          <div className="mpr-filter-field">
            <label>Month</label>
            <select
              className="mpr-select"
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(e.target.value)}
              disabled={isFilterBusy}
            >
              <option value="">All Months</option>
              {MONTHS.map((item) => <option key={item.value} value={item.value}>{item.label}</option>)}
            </select>
          </div>
          {isAdmin && (
            <div className="mpr-filter-field">
              <label>Client</label>
              <select
                className="mpr-select"
                value={selectedClient}
                onChange={(e) => setSelectedClient(e.target.value)}
                disabled={isFilterBusy}
              >
                <option value="">All Clients</option>
                {clientOptions.map((item) => <option key={item.value} value={item.value}>{item.label}</option>)}
              </select>
            </div>
          )}
          {isAdmin && (
            <div className="mpr-filter-field">
              <label>Care Provider</label>
              <Select
                isMulti
                isDisabled={isFilterBusy}
                styles={PROVIDER_SELECT_STYLES}
                placeholder="All Care Providers"
                value={selectedProviderOptions}
                options={careProviderOptions}
                onChange={(options) => setSelectedProviders((options || []).map((option) => option.value))}
              />
            </div>
          )}
          <div className="mpr-filter-actions mpr-simple-filter-actions">
            <button
              type="button"
              className={`mpr-apply-btn ${isFilterBusy ? "mpr-apply-btn--loading" : ""}`}
              onClick={handleApply}
              aria-busy={isFilterBusy}
            >
              {isFilterBusy ? <i className="mdi mdi-loading mdi-spin" /> : <i className="mdi mdi-filter" />}
              {isFilterBusy ? "Loading..." : "Filter"}
            </button>
            <button type="button" className="mpr-reset-btn" onClick={handleReset} disabled={isFilterBusy}>
              <i className="mdi mdi-refresh"></i>
              Reset
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarePlanReviewFilters;
